// store/slices/subCategorySlice.ts
import { Category } from "@/app/types";
import apiClient from "@/app/utils/apiClient";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

// =================== SUBCATEGORY TYPES ==================

export interface SubCategory {
  _id: string;
  name: string;
  // categoryId?: string;
  categoryId?: Category;
  isActive: boolean;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface SubCategoryState {
  subCategories: SubCategory[];
  loading: boolean;
  error: string | null;
  success: string | null;
}

const initialSubCategoryState: SubCategoryState = {
  subCategories: [],
  loading: false,
  error: null,
  success: null,
};

// ================== FETCH PUBLIC SUBCATEGORIES (FOR USERS) ==================
export const fetchSubCategories = createAsyncThunk<
  SubCategory[],
  void,
  { rejectValue: string }
>("subCategories/fetchSubCategories", async (_, { rejectWithValue }) => {
  try {
    // Public endpoint that returns all subcategories from all admins
    const response = await apiClient.get("/admin/subcategories");
    return response.data;
  } catch (err: any) {
    return rejectWithValue(
      err.response?.data?.message || "Failed to fetch subcategories",
    );
  }
});

const subCategorySlice = createSlice({
  name: "subCategories",
  initialState: initialSubCategoryState,
  reducers: {
    clearSubCategoryMessages: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch SubCategories
      .addCase(fetchSubCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(
        fetchSubCategories.fulfilled,
        (state, action: PayloadAction<SubCategory[]>) => {
          state.loading = false;
          state.subCategories = action.payload;
          state.success = "Subcategories fetched successfully";
        },
      )
      .addCase(fetchSubCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch subcategories";
      });
  },
});

export const { clearSubCategoryMessages } = subCategorySlice.actions;
export default subCategorySlice.reducer;
